import { useState } from "react";

export const useSelect = (defaultValue = "") => {
  const [value, setValue] = useState<string>(defaultValue);

  return {
    value,
    setValue,
  };
};
